import Icon from './Icon'

function Segui({ following, onClick = () => {}, horizontal = false }) {
  return (
    <div
      className={`segui ${horizontal ? 'segui--horizontal' : ''} ${
        following ? 'segui--follow' : ''
      }`}
      onClick={onClick}
    >
      <Icon
        id={following ? 'follow' : 'follow'}
        classes="icon--heart"
        tooltip={following ? 'Smetti di seguire' : 'Segui'}
      />
    </div>
  )
}

export default Segui
